// Mock Financial Summary Data - İNSANET
// Gelir-Gider Raporu özet verileri

export const mockFinancialSummary = [
    // YEŞİL PARK KONUTLARI
    {
        constructionId: 'c1',
        constructionName: 'Yeşil Park Konutları',
        period: '2025-2026',
        income: {
            apartmentSales: 10500000,
            installments: 2000000,
            other: 0,
            total: 12500000,
        },
        expense: {
            materials: 3200000,
            labor: 2800000,
            infrastructure: 650000,
            permits: 180000,
            utilities: 220000,
            other: 750000,
            total: 7800000,
        },
        netBalance: 4700000,
        // Tahsilat durumu
        collections: {
            collected: 10200000,
            pending: 2300000,
            overdue: 450000,
        },
        // Ödeme durumu (firmalara)
        payments: {
            paid: 7500000,
            pending: 300000,
            scheduled: 1200000,
        },
        monthlyBreakdown: [
            {
                month: '2025-01', monthLabel: 'Oca 2025',
                income: 500000, expense: 850000,
                incomeCategories: { apartmentSales: 0, installments: 400000, kapora: 100000 },
                expenseCategories: { materials: 450000, labor: 280000, infrastructure: 80000, other: 40000 },
                transactions: [
                    { id: 'yp-t1', date: '2025-01-05', type: 'income', category: 'Taksit', person: 'Mustafa Aydın', amount: 200000, description: 'A-8 dairesi taksit' },
                    { id: 'yp-t2', date: '2025-01-12', type: 'expense', category: 'Malzeme', person: 'Anadolu Beton', amount: 250000, description: 'Beton temini' },
                    { id: 'yp-t3', date: '2025-01-18', type: 'income', category: 'Taksit', person: 'Fatma Demir', amount: 200000, description: 'A-5 dairesi taksit' },
                    { id: 'yp-t4', date: '2025-01-22', type: 'expense', category: 'İşçilik', person: 'Demir Yapı', amount: 280000, description: 'Kaba inşaat işçilik' },
                ]
            },
            {
                month: '2025-02', monthLabel: 'Şub 2025',
                income: 2500000, expense: 680000,
                incomeCategories: { apartmentSales: 2000000, installments: 400000, kapora: 100000 },
                expenseCategories: { materials: 350000, labor: 220000, infrastructure: 70000, other: 40000 },
                transactions: [
                    { id: 'yp-t5', date: '2025-02-08', type: 'income', category: 'Satış', person: 'Fatma Demir', amount: 2000000, description: 'A-5 dairesi peşinat' },
                    { id: 'yp-t6', date: '2025-02-15', type: 'expense', category: 'Malzeme', person: 'İstanbul Demir Çelik', amount: 350000, description: 'Demir teslimatı' },
                ]
            },
            {
                month: '2025-03', monthLabel: 'Mar 2025',
                income: 1200000, expense: 750000,
                incomeCategories: { apartmentSales: 800000, installments: 300000, kapora: 100000 },
                expenseCategories: { materials: 380000, labor: 250000, infrastructure: 80000, other: 40000 },
                transactions: [
                    { id: 'yp-t7', date: '2025-03-05', type: 'income', category: 'Satış', person: 'Mehmet Yıldız', amount: 800000, description: 'B-3 dairesi peşinat' },
                    { id: 'yp-t8', date: '2025-03-18', type: 'expense', category: 'İşçilik', person: 'Demir Yapı', amount: 250000, description: '2. hakediş ödemesi' },
                ]
            },
            {
                month: '2025-04', monthLabel: 'Nis 2025',
                income: 800000, expense: 620000,
                incomeCategories: { apartmentSales: 400000, installments: 300000, kapora: 100000 },
                expenseCategories: { materials: 300000, labor: 200000, infrastructure: 80000, other: 40000 },
                transactions: [
                    { id: 'yp-t9', date: '2025-04-10', type: 'expense', category: 'Malzeme', person: 'Yıldız Seramik', amount: 180000, description: 'Seramik alımı' },
                    { id: 'yp-t10', date: '2025-04-22', type: 'income', category: 'Taksit', person: 'Fatma Demir', amount: 300000, description: 'A-5 dairesi 2. taksit' },
                ]
            },
            {
                month: '2025-05', monthLabel: 'May 2025',
                income: 1900000, expense: 580000,
                incomeCategories: { apartmentSales: 1400000, installments: 400000, kapora: 100000 },
                expenseCategories: { materials: 280000, labor: 200000, infrastructure: 60000, other: 40000 },
                transactions: [
                    { id: 'yp-t11', date: '2025-05-07', type: 'income', category: 'Satış', person: 'Hasan Kaya', amount: 1400000, description: 'A-12 dairesi peşinat' },
                    { id: 'yp-t12', date: '2025-05-15', type: 'expense', category: 'Altyapı', person: 'Anadolu Tesisat', amount: 120000, description: 'Su tesisatı döşeme' },
                ]
            },
            {
                month: '2025-06', monthLabel: 'Haz 2025',
                income: 1500000, expense: 700000,
                incomeCategories: { apartmentSales: 1000000, installments: 350000, kapora: 150000 },
                expenseCategories: { materials: 350000, labor: 230000, infrastructure: 80000, other: 40000 },
                transactions: [
                    { id: 'yp-t13', date: '2025-06-03', type: 'expense', category: 'Malzeme', person: 'İstanbul Demir Çelik', amount: 200000, description: 'Haziran demir teslimatı' },
                    { id: 'yp-t14', date: '2025-06-20', type: 'income', category: 'Taksit', person: 'Mustafa Aydın', amount: 200000, description: 'A-8 dairesi 3. taksit' },
                ]
            },
            {
                month: '2025-07', monthLabel: 'Tem 2025',
                income: 1000000, expense: 650000,
                incomeCategories: { apartmentSales: 600000, installments: 300000, kapora: 100000 },
                expenseCategories: { materials: 320000, labor: 220000, infrastructure: 70000, other: 40000 },
                transactions: []
            },
            {
                month: '2025-08', monthLabel: 'Ağu 2025',
                income: 1200000, expense: 580000,
                incomeCategories: { apartmentSales: 700000, installments: 350000, kapora: 150000 },
                expenseCategories: { materials: 280000, labor: 200000, infrastructure: 60000, other: 40000 },
                transactions: []
            },
            {
                month: '2025-09', monthLabel: 'Eyl 2025',
                income: 800000, expense: 620000,
                incomeCategories: { apartmentSales: 400000, installments: 300000, kapora: 100000 },
                expenseCategories: { materials: 300000, labor: 200000, infrastructure: 80000, other: 40000 },
                transactions: []
            },
            {
                month: '2025-10', monthLabel: 'Eki 2025',
                income: 600000, expense: 550000,
                incomeCategories: { apartmentSales: 200000, installments: 300000, kapora: 100000 },
                expenseCategories: { materials: 250000, labor: 200000, infrastructure: 60000, other: 40000 },
                transactions: []
            },
            {
                month: '2025-11', monthLabel: 'Kas 2025',
                income: 300000, expense: 520000,
                incomeCategories: { apartmentSales: 0, installments: 200000, kapora: 100000 },
                expenseCategories: { materials: 240000, labor: 180000, infrastructure: 60000, other: 40000 },
                transactions: []
            },
            {
                month: '2025-12', monthLabel: 'Ara 2025',
                income: 200000, expense: 500000,
                incomeCategories: { apartmentSales: 0, installments: 150000, kapora: 50000 },
                expenseCategories: { materials: 220000, labor: 180000, infrastructure: 60000, other: 40000 },
                transactions: []
            },
            // 2026 verileri
            {
                month: '2026-01', monthLabel: 'Oca 2026',
                income: 2800000, expense: 920000,
                incomeCategories: { apartmentSales: 2000000, installments: 600000, kapora: 200000 },
                expenseCategories: { materials: 480000, labor: 320000, infrastructure: 80000, other: 40000 },
                transactions: [
                    { id: 'yp-26-1', date: '2026-01-02', type: 'income', category: 'Satış', person: 'Burak Yılmaz', amount: 2000000, description: 'A-10 dairesi peşinat' },
                    { id: 'yp-26-2', date: '2026-01-03', type: 'income', category: 'Taksit', person: 'Fatma Demir', amount: 300000, description: 'A-5 dairesi taksit' },
                    { id: 'yp-26-3', date: '2026-01-03', type: 'expense', category: 'Malzeme', person: 'Anadolu Beton', amount: 280000, description: 'Ocak beton siparişi' },
                ]
            },
            {
                month: '2026-02', monthLabel: 'Şub 2026',
                income: 1500000, expense: 1200000,
                incomeCategories: { apartmentSales: 1000000, installments: 400000, kapora: 100000 },
                expenseCategories: { materials: 600000, labor: 400000, infrastructure: 100000, other: 100000 },
                transactions: []
            },
            {
                month: '2026-03', monthLabel: 'Mar 2026',
                income: 3200000, expense: 1500000,
                incomeCategories: { apartmentSales: 2500000, installments: 500000, kapora: 200000 },
                expenseCategories: { materials: 800000, labor: 500000, infrastructure: 100000, other: 100000 },
                transactions: []
            },

        ],

        // Son işlemler
        recentTransactions: [
            { id: 't1_2026', date: '2026-03-10', type: 'income', category: 'Satış', person: 'Burak Yılmaz', amount: 2000000, description: 'A-10 dairesi peşinat' },
            { id: 't1', date: '2025-08-28', type: 'income', category: 'Taksit', person: 'Ahmet Yılmaz', amount: 200000, description: 'A-3 dairesi 3. taksit' },

            { id: 't2', date: '2025-08-25', type: 'expense', category: 'Malzeme', person: 'Anadolu Beton', amount: 180000, description: 'Beton teslimatı' },
            { id: 't3', date: '2025-08-22', type: 'income', category: 'Taksit', person: 'Zeynep Arslan', amount: 150000, description: 'B-2 dairesi 3. taksit' },
            { id: 't4', date: '2025-08-20', type: 'expense', category: 'İşçilik', person: 'Demir Yapı', amount: 350000, description: '5. hakediş ödemesi' },
            { id: 't5', date: '2025-08-18', type: 'income', category: 'Kapora', person: 'Yeni Müşteri', amount: 300000, description: 'B-5 dairesi kapora' },
            { id: 't11', date: '2026-02-10', type: 'expense', category: 'Malzeme', person: 'İstanbul Demir Çelik', amount: 520000, description: 'Şubat demir siparişi' },
            { id: 't12', date: '2026-02-18', type: 'income', category: 'Taksit', person: 'Mehmet Yıldız', amount: 250000, description: 'B-3 dairesi 4. taksit' },
            { id: 't13', date: '2026-03-05', type: 'expense', category: 'İşçilik', person: 'Demir Yapı', amount: 480000, description: '8. hakediş ödemesi' },
            { id: 't14', date: '2026-03-12', type: 'expense', category: 'Fatura', person: 'İGDAŞ', amount: 35000, description: 'Şantiye doğalgaz faturası' },
            { id: 't15', date: '2026-01-25', type: 'expense', category: 'Altyapı', person: 'Anadolu Tesisat', amount: 180000, description: 'Merkezi ısıtma sistemi' },
            { id: 't16', date: '2026-01-10', type: 'income', category: 'Satış', person: 'Selin Koç', amount: 1800000, description: 'B-8 dairesi peşinat' },
            { id: 't17', date: '2026-02-25', type: 'expense', category: 'İzin', person: 'Belediye', amount: 45000, description: 'Yapı denetim harcı' },
            { id: 't18', date: '2026-03-18', type: 'income', category: 'Taksit', person: 'Hasan Kaya', amount: 350000, description: 'A-12 dairesi 5. taksit' },
        ],
    },


    // MAVİ DENİZ REZİDANS
    {
        constructionId: 'c2',
        constructionName: 'Global Rezidans',
        period: '2025-2026',
        income: {
            apartmentSales: 21000000,
            installments: 4000000,
            other: 0,
            total: 25000000,
        },
        expense: {
            materials: 5200000,
            labor: 4100000,
            infrastructure: 1200000,
            permits: 350000,
            utilities: 380000,
            other: 770000,
            total: 12000000,
        },
        netBalance: 13000000,
        collections: {
            collected: 20500000,
            pending: 4500000,
            overdue: 800000,
        },
        payments: {
            paid: 11200000,
            pending: 800000,
            scheduled: 2500000,
        },
        monthlyBreakdown: [
            {
                month: '2025-06', monthLabel: 'Haz 2025',
                income: 3200000, expense: 1800000,
                incomeCategories: { apartmentSales: 2500000, installments: 500000, kapora: 200000 },
                expenseCategories: { materials: 900000, labor: 600000, infrastructure: 200000, other: 100000 },
                transactions: [
                    { id: 'md-t1', date: '2025-06-10', type: 'income', category: 'Satış', person: 'Ali Çelik', amount: 2500000, description: 'C-1 dairesi peşinat' },
                    { id: 'md-t2', date: '2025-06-20', type: 'expense', category: 'Malzeme', person: 'Anadolu Beton', amount: 600000, description: 'Beton temini' },
                ]
            },
            {
                month: '2025-07', monthLabel: 'Tem 2025',
                income: 4500000, expense: 1950000,
                incomeCategories: { apartmentSales: 3800000, installments: 500000, kapora: 200000 },
                expenseCategories: { materials: 1000000, labor: 650000, infrastructure: 200000, other: 100000 },
                transactions: []
            },
            {
                month: '2025-08', monthLabel: 'Ağu 2025',
                income: 5100000, expense: 2100000,
                incomeCategories: { apartmentSales: 4200000, installments: 600000, kapora: 300000 },
                expenseCategories: { materials: 1100000, labor: 700000, infrastructure: 200000, other: 100000 },
                transactions: []
            },
            {
                month: '2025-09', monthLabel: 'Eyl 2025',
                income: 4200000, expense: 1850000,
                incomeCategories: { apartmentSales: 3400000, installments: 600000, kapora: 200000 },
                expenseCategories: { materials: 900000, labor: 650000, infrastructure: 200000, other: 100000 },
                transactions: []
            },
            {
                month: '2025-10', monthLabel: 'Eki 2025',
                income: 3800000, expense: 1750000,
                incomeCategories: { apartmentSales: 3000000, installments: 600000, kapora: 200000 },
                expenseCategories: { materials: 850000, labor: 600000, infrastructure: 200000, other: 100000 },
                transactions: []
            },
            {
                month: '2025-11', monthLabel: 'Kas 2025',
                income: 2500000, expense: 1550000,
                incomeCategories: { apartmentSales: 1800000, installments: 500000, kapora: 200000 },
                expenseCategories: { materials: 750000, labor: 550000, infrastructure: 150000, other: 100000 },
                transactions: []
            },
            {
                month: '2025-12', monthLabel: 'Ara 2025',
                income: 1700000, expense: 1000000,
                incomeCategories: { apartmentSales: 1000000, installments: 500000, kapora: 200000 },
                expenseCategories: { materials: 450000, labor: 350000, infrastructure: 100000, other: 100000 },
                transactions: []
            },
            // 2026 verileri
            {
                month: '2026-01', monthLabel: 'Oca 2026',
                income: 5200000, expense: 2500000,
                incomeCategories: { apartmentSales: 4000000, installments: 800000, kapora: 400000 },
                expenseCategories: { materials: 1200000, labor: 800000, infrastructure: 300000, other: 200000 },
                transactions: []
            },
            {
                month: '2026-02', monthLabel: 'Şub 2026',
                income: 4800000, expense: 2200000,
                incomeCategories: { apartmentSales: 3500000, installments: 800000, kapora: 500000 },
                expenseCategories: { materials: 1000000, labor: 700000, infrastructure: 300000, other: 200000 },
                transactions: []
            },
        ],

        recentTransactions: [
            { id: 't6_2026', date: '2026-01-27', type: 'income', category: 'Taksit', person: 'Ayşe Öztürk', amount: 250000, description: 'B-4 dairesi 2. taksit' },
            { id: 't6', date: '2025-08-27', type: 'income', category: 'Taksit', person: 'Ayşe Öztürk', amount: 250000, description: 'B-4 dairesi 2. taksit' },

            { id: 't7', date: '2025-08-24', type: 'expense', category: 'Malzeme', person: 'Çelik Tesisat', amount: 420000, description: 'Tesisat malzemesi' },
            { id: 't8', date: '2025-08-21', type: 'income', category: 'Kapora', person: 'Elif Şahin', amount: 1500000, description: 'A-5 dairesi kapora' },
            { id: 't9', date: '2025-08-19', type: 'expense', category: 'İşçilik', person: 'Elektrik Taşeron', amount: 280000, description: 'Elektrik işçiliği' },
            { id: 't10', date: '2025-08-16', type: 'income', category: 'Taksit', person: 'Selin Koç', amount: 200000, description: 'B-8 dairesi 1. taksit' },
        ],
    },
];

// Helper functions
export const getFinancialSummaryByConstructionId = (constructionId, selectedYear = null) => {
    let rawSummary;
    if (!constructionId) {
        // Tüm inşaatlar için birleşik özet temel yapısı
        rawSummary = {
            constructionId: null,
            constructionName: 'Tüm İnşaatlar',
            period: '2025-2026',
            income: { apartmentSales: 0, installments: 0, other: 0, total: 0 },
            expense: { materials: 0, labor: 0, infrastructure: 0, permits: 0, utilities: 0, other: 0, total: 0 },
            netBalance: 0,
            collections: { collected: 0, pending: 0, overdue: 0 }, // Bunlar kümülatif kalabilir
            payments: { paid: 0, pending: 0, scheduled: 0 },     // Bunlar kümülatif kalabilir
            monthlyBreakdown: [],
            recentTransactions: [],
        };

        mockFinancialSummary.forEach(fs => {
            rawSummary.income.apartmentSales += fs.income.apartmentSales;
            rawSummary.income.installments += fs.income.installments;
            rawSummary.income.total += fs.income.total;
            rawSummary.expense.materials += fs.expense.materials;
            rawSummary.expense.labor += fs.expense.labor;
            rawSummary.expense.infrastructure += fs.expense.infrastructure;
            rawSummary.expense.permits += fs.expense.permits;
            rawSummary.expense.utilities += fs.expense.utilities;
            rawSummary.expense.other += fs.expense.other;
            rawSummary.expense.total += fs.expense.total;
            rawSummary.netBalance += fs.netBalance;
            rawSummary.collections.collected += fs.collections.collected;
            rawSummary.collections.pending += fs.collections.pending;
            rawSummary.collections.overdue += (fs.collections.overdue || 0);
            rawSummary.payments.paid += fs.payments.paid;
            rawSummary.payments.pending += fs.payments.pending;
            rawSummary.payments.scheduled += fs.payments.scheduled;

            // Tüm ayları ve işlemleri topla
            rawSummary.monthlyBreakdown.push(...(fs.monthlyBreakdown || []));
            rawSummary.recentTransactions.push(...(fs.recentTransactions || []));
        });
    } else {
        const found = mockFinancialSummary.find(fs => fs.constructionId === constructionId);
        if (!found) return null;
        rawSummary = JSON.parse(JSON.stringify(found)); // Deep copy to avoid mutating mock
    }

    // YIL FİLTRESİ UYGULAMA (Kullanıcı seçtiyse)
    if (selectedYear) {
        // Önce tüm inşaatlar birleşik ise ayları merge et
        if (!constructionId) {
            const monthlyMap = new Map();
            rawSummary.monthlyBreakdown.forEach(m => {
                if (monthlyMap.has(m.month)) {
                    const existing = monthlyMap.get(m.month);
                    existing.income += m.income;
                    existing.expense += m.expense;
                    // Kategorileri de birleştir
                    if (m.incomeCategories && existing.incomeCategories) {
                        Object.keys(m.incomeCategories).forEach(key => {
                            existing.incomeCategories[key] = (existing.incomeCategories[key] || 0) + (m.incomeCategories[key] || 0);
                        });
                    }
                    if (m.expenseCategories && existing.expenseCategories) {
                        Object.keys(m.expenseCategories).forEach(key => {
                            existing.expenseCategories[key] = (existing.expenseCategories[key] || 0) + (m.expenseCategories[key] || 0);
                        });
                    }
                    // Transaction'ları birleştir
                    if (m.transactions) {
                        existing.transactions = [...(existing.transactions || []), ...m.transactions];
                    }
                } else {
                    monthlyMap.set(m.month, { ...m, incomeCategories: { ...m.incomeCategories }, expenseCategories: { ...m.expenseCategories }, transactions: [...(m.transactions || [])] });
                }
            });
            rawSummary.monthlyBreakdown = Array.from(monthlyMap.values())
                .sort((a, b) => a.month.localeCompare(b.month));
        }

        // 1. Aylık dökümü filtrele
        rawSummary.monthlyBreakdown = rawSummary.monthlyBreakdown.filter(m => m.month.startsWith(selectedYear));

        // 2. İşlemleri filtrele
        rawSummary.recentTransactions = rawSummary.recentTransactions
            .filter(t => t.date.startsWith(selectedYear))
            .sort((a, b) => new Date(b.date) - new Date(a.date))
            .slice(0, 10);

        // 3. Gelir/Gider toplamlarını bu yılın aylarına göre YENİDEN HESAPLA
        const yearlyIncome = { apartmentSales: 0, installments: 0, other: 0, total: 0 };
        const yearlyExpense = { materials: 0, labor: 0, infrastructure: 0, permits: 0, utilities: 0, other: 0, total: 0 };

        rawSummary.monthlyBreakdown.forEach(m => {
            yearlyIncome.apartmentSales += (m.incomeCategories?.apartmentSales || 0);
            yearlyIncome.installments += (m.incomeCategories?.installments || 0);
            yearlyIncome.other += (m.incomeCategories?.kapora || 0); // Kapora'yı diğer sayalım mock için
            yearlyIncome.total += m.income;

            yearlyExpense.materials += (m.expenseCategories?.materials || 0);
            yearlyExpense.labor += (m.expenseCategories?.labor || 0);
            yearlyExpense.infrastructure += (m.expenseCategories?.infrastructure || 0);
            yearlyExpense.other += (m.expenseCategories?.other || 0);
            yearlyExpense.total += m.expense;
        });

        rawSummary.income = yearlyIncome;
        rawSummary.expense = yearlyExpense;
        rawSummary.netBalance = yearlyIncome.total - yearlyExpense.total;
        rawSummary.period = selectedYear;
    } else {
        // Kümülatif (Tüm yıllar) durumunda aylık dökümü düzgünce birleştir (Tüm inşaatlar seçiliyse)
        if (!constructionId) {
            const monthlyMap = new Map();
            rawSummary.monthlyBreakdown.forEach(m => {
                if (monthlyMap.has(m.month)) {
                    const existing = monthlyMap.get(m.month);
                    existing.income += m.income;
                    existing.expense += m.expense;
                } else {
                    monthlyMap.set(m.month, { ...m });
                }
            });
            rawSummary.monthlyBreakdown = Array.from(monthlyMap.values())
                .sort((a, b) => a.month.localeCompare(b.month));

            rawSummary.recentTransactions = rawSummary.recentTransactions
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .slice(0, 10);
        }
    }


    return rawSummary;
};


// Kişilerden alacak özeti
export const getReceivablesSummary = (constructionId) => {
    // Mock data - gerçek veriler individuals.js'ten gelecek
    return [
        { id: 'ind-1', name: 'Ahmet Yılmaz', totalRemaining: 1900000, lastPaymentDate: '2025-08-15', status: 'normal' },
        { id: 'ind-4', name: 'Ayşe Öztürk', totalRemaining: 3250000, lastPaymentDate: '2025-08-01', status: 'normal' },
        { id: 'ind-5', name: 'Ali Çelik', totalRemaining: 3600000, lastPaymentDate: '2025-05-10', status: 'overdue' },
        { id: 'ind-6', name: 'Zeynep Arslan', totalRemaining: 1900000, lastPaymentDate: '2025-08-01', status: 'normal' },
        { id: 'ind-8', name: 'Elif Şahin', totalRemaining: 3300000, lastPaymentDate: '2025-08-01', status: 'normal' },
    ];
};

// Firmalara borç özeti
export const getPayablesSummary = (constructionId) => {
    // Mock data - gerçek veriler companies.js'ten gelecek
    return [
        { id: 'comp-1', name: 'Demir Yapı', totalRemaining: 1000000, nextPaymentDate: '2025-09-15', status: 'scheduled' },
        { id: 'comp-2', name: 'Öztürk Elektrik', totalRemaining: 3900000, nextPaymentDate: '2025-10-01', status: 'scheduled' },
        { id: 'comp-3', name: 'Çelik Tesisat', totalRemaining: 2200000, nextPaymentDate: '2025-09-01', status: 'pending' },
        { id: 'comp-4', name: 'Anadolu Beton', totalRemaining: 3600000, nextPaymentDate: '2025-08-15', status: 'overdue' },
    ];
};

export default mockFinancialSummary;
